import * as React from "react"
import {Box} from "@mui/material";

import { showMoreTags } from "../../../@signals";


export default function tagsColumn() {
	return [{
		name: "tagsOrder", label: 'Visible tags',
		options: {
			display: 'excluded',
			filterType: "textField"
		}
	},{
		name: 'tagsOrder', label: 'Visible tags',
		options: {
			filter: false,
			customBodyRowRenderLite: (_, { tags }, { rowIndex }) => {
				const visibleTags = tags.slice(0, 3)
				const rest = tags.slice(3)

				const handleClick = () => showMoreTags.value = rowIndex
				const tagClicked = rowIndex === showMoreTags.value

				return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
					<Box sx={{ display: 'flex', gap: 1 }}>
						{visibleTags.map(vt => <PurpleLabel key={vt} text={vt} />)}
						{ !!rest.length && !tagClicked && <PurpleLabel text={`+${rest.length}`} onClick={handleClick} /> }
						{ !!tagClicked && <PurpleLabel text={`Hide Tags`} onClick={() => showMoreTags.value = null} backgroundColor="info.light" /> }
					</Box>
					{ !!tagClicked && <Box sx={{ display: 'flex', gap: 1, fontSize: 12 }}>
						{ rest.map(vt => <PurpleLabel key={vt} text={vt} small />) }
					</Box> }
				</Box>
			}
		}
	}]
}

const PurpleLabel = ({ text, onClick, backgroundColor=null, small=false }) => <Box component="span" sx={{
	py: small ? 1 : 2,
	px: small ? 2 : 4,
	borderRadius: 1.2,
	backgroundColor: backgroundColor || '#f5d6f9',
	cursor: onClick ? 'pointer' : 'normal'
}}  onClick={onClick}>
	{text}
</Box>